module.exports = __webpack_public_path__ + "static/media/ModalImage.2d074f7b.png";